import script from "./BidStepCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./BidStepCard.vue?vue&type=script&setup=true&lang=ts"

import "./BidStepCard.vue?vue&type=style&index=0&id=cc0b0e8c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc0b0e8c"]])

export default __exports__